import {Button, Checkbox, Flex, FormControl, SimpleGrid, Stack, Text} from "@chakra-ui/react";
import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

function BoatConditionsForm({onSubmit, onBack, values}) {

    const {t} = useTranslation();

    const ids = useMemo(() => ({
        luminosidade: "luminosidade",
        amanhecendo: "amanhecendo",
        plenoDia: "plenoDia",
        anoitecendo: "anoitecendo",
        noiteComIluminacao: "noiteComIluminacao",
        noiteSemIluminacao: "noiteSemIluminacao",
        deficiente: "deficiente",
        condicaoDoTempo: "condicaoDoTempo",
        bom: "bom",
        nublado: "nublado",
        chuva: "chuva",
        neblina: "neblina",
        outros: "outros",
        tipoDaPista: "tipoDaPista",
        asfalto: "asfalto",
        paralelepipedo: "paralelepipedo",
        concreto: "concreto",
        cascalho: "cascalho",
        caracteristicaDaPista: "caracteristicaDaPista",
        acliveIngreme: "acliveIngreme",
        acliveSuave: "acliveSuave",
        lombada: "lombada",
        cruzamento: "cruzamento",
        retorno: "retorno",
        entroncamento: "entroncamento",
        bifurcacao: "bifurcacao",
        pista: "pista",
        molhada: "molhada",
        inundada: "inundada",
        pocaDeAgua: "pocaDeAgua",
        oleosa: "oleosa",
        enlameada: "enlameada",
        emObras: "emObras",
        comBuraco: "comBuraco",
        sinalizacao: "sinalizacao",
        inexistente: "inexistente",
        agenteMobilidadeUrbana: "agenteMobilidadeUrbana",
        semaforo: "semaforo",
        faixaDePedestre: "faixaDePedestre",
        linha: "linha",
        lombadaEletronica: "lombadaEletronica"
    }), []);

    const initFormData = (data) => {
        return {
            luminosidade: {
                amanhecendo: data?.luminosidade?.amanhecendo || false,
                plenoDia: data?.luminosidade?.plenoDia || false,
                anoitecendo: data?.luminosidade?.anoitecendo || false,
                noiteComIluminacao: data?.luminosidade?.noiteComIluminacao || false,
                noiteSemIluminacao: data?.luminosidade?.noiteSemIluminacao || false,
                deficiente: data?.luminosidade?.deficiente || false
            },
            condicaoDoTempo: {
                bom: data?.condicaoDoTempo?.bom || false,
                nublado: data?.condicaoDoTempo?.nublado || false,
                chuva: data?.condicaoDoTempo?.chuva || false,
                neblina: data?.condicaoDoTempo?.neblina || false,
                outros: data?.condicaoDoTempo?.outros || false
            },
            tipoDaPista: {
                asfalto: data?.tipoDaPista?.asfalto || false,
                paralelepipedo: data?.tipoDaPista?.paralelepipedo || false,
                concreto: data?.tipoDaPista?.concreto || false,
                cascalho: data?.tipoDaPista?.cascalho || false,
                outros: data?.tipoDaPista?.outros || false
            },
            caracteristicaDaPista: {
                acliveIngreme: data?.caracteristicaDaPista?.acliveIngreme || false,
                acliveSuave: data?.caracteristicaDaPista?.acliveSuave || false,
                lombada: data?.caracteristicaDaPista?.lombada || false,
                cruzamento: data?.caracteristicaDaPista?.cruzamento || false,
                retorno: data?.caracteristicaDaPista?.retorno || false,
                entroncamento: data?.caracteristicaDaPista?.entroncamento || false,
                bifurcacao: data?.caracteristicaDaPista?.bifurcacao || false,
                outros: data?.caracteristicaDaPista?.outros || false
            },
            pista: {
                molhada: data?.pista?.molhada || false,
                inundada: data?.pista?.inundada || false,
                pocaDeAgua: data?.pista?.pocaDeAgua || false,
                oleosa: data?.pista?.oleosa || false,
                enlameada: data?.pista?.enlameada || false,
                emObras: data?.pista?.emObras || false,
                comBuraco: data?.pista?.comBuraco || false,
                outros: data?.pista?.outros || false
            },
            sinalizacao: {
                inexistente: data?.sinalizacao?.inexistente || false,
                agenteMobilidadeUrbana: data?.sinalizacao?.agenteMobilidadeUrbana || false,
                semaforo: data?.sinalizacao?.semaforo || false,
                faixaDePedestre: data?.sinalizacao?.faixaDePedestre || false,
                linha: data?.sinalizacao?.linha || false,
                lombadaEletronica: data?.sinalizacao?.lombadaEletronica || false,
                outros: data?.sinalizacao?.outros || false
            }
        };
    }

    const [formData, setFormData] = useState(initFormData(values));

    const handleInputChange = (e) => {
        const idTokens = e.target.id.split("-");
        const value = e.target.checked;

        const key = idTokens[0];
        const att = idTokens[1];

        formData[key][att] = value;

        const newFormData = {...formData};
        setFormData(newFormData);
    };

    const handleOnSubmit = () => {
        onSubmit(formData);
    }

    const saveDraft = () => {
        onSubmit(formData, true)
    }

    return (
        <>
            <Stack>
                <Text fontWeight="bold">{t('boat.new.lighting.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.amanhecendo]}
                            id={`${[ids.luminosidade]}-${[ids.amanhecendo]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.dawn")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.plenoDia]}
                            id={`${[ids.luminosidade]}-${[ids.plenoDia]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.full-day")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.anoitecendo]}
                            id={`${[ids.luminosidade]}-${[ids.anoitecendo]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.dusk")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.noiteComIluminacao]}
                            id={`${[ids.luminosidade]}-${[ids.noiteComIluminacao]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.night-with-lighting")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.noiteSemIluminacao]}
                            id={`${[ids.luminosidade]}-${[ids.noiteSemIluminacao]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.night-without-lighting")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.luminosidade][ids.deficiente]}
                            id={`${[ids.luminosidade]}-${[ids.deficiente]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.lighting.poor")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Stack mt="10px">
                <Text fontWeight="bold">{t('boat.new.weather-conditions.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.condicaoDoTempo][ids.bom]}
                            id={`${[ids.condicaoDoTempo]}-${[ids.bom]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.weather-conditions.good")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.condicaoDoTempo][ids.nublado]}
                            id={`${[ids.condicaoDoTempo]}-${[ids.nublado]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.weather-conditions.cloudy")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.condicaoDoTempo][ids.chuva]}
                            id={`${[ids.condicaoDoTempo]}-${[ids.chuva]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.weather-conditions.rain")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.condicaoDoTempo][ids.neblina]}
                            id={`${[ids.condicaoDoTempo]}-${[ids.neblina]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.weather-conditions.foggy")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.condicaoDoTempo][ids.outros]}
                            id={`${[ids.condicaoDoTempo]}-${[ids.outros]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.others")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Stack mt="10px">
                <Text fontWeight="bold">{t('boat.new.road-type.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.tipoDaPista][ids.asfalto]}
                            id={`${[ids.tipoDaPista]}-${[ids.asfalto]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-type.asphalt")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.tipoDaPista][ids.paralelepipedo]}
                            id={`${[ids.tipoDaPista]}-${[ids.paralelepipedo]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-type.paving-stone")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.tipoDaPista][ids.concreto]}
                            id={`${[ids.tipoDaPista]}-${[ids.concreto]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-type.concrete")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.tipoDaPista][ids.cascalho]}
                            id={`${[ids.tipoDaPista]}-${[ids.cascalho]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-type.gravel")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.tipoDaPista][ids.outros]}
                            id={`${[ids.tipoDaPista]}-${[ids.outros]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.others")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Stack mt="10px">
                <Text fontWeight="bold">{t('boat.new.road-characteristic.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.acliveIngreme]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.acliveIngreme]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.steep-slope")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.acliveSuave]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.acliveSuave]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.gentle-slope")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.lombada]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.lombada]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.bump")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.cruzamento]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.cruzamento]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.crossing")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.retorno]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.retorno]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.u-turn")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.entroncamento]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.entroncamento]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.junction")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.bifurcacao]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.bifurcacao]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road-characteristic.bifurcation")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.caracteristicaDaPista][ids.outros]}
                            id={`${[ids.caracteristicaDaPista]}-${[ids.outros]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.others")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Stack mt="10px">
                <Text fontWeight="bold">{t('boat.new.road.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.molhada]}
                            id={`${[ids.pista]}-${[ids.molhada]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.wet")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.inundada]}
                            id={`${[ids.pista]}-${[ids.inundada]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.flood")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.pocaDeAgua]}
                            id={`${[ids.pista]}-${[ids.pocaDeAgua]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.puddle-water")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.oleosa]}
                            id={`${[ids.pista]}-${[ids.oleosa]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.oily")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.enlameada]}
                            id={`${[ids.pista]}-${[ids.enlameada]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.muddy")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.emObras]}
                            id={`${[ids.pista]}-${[ids.emObras]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.construction")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.comBuraco]}
                            id={`${[ids.pista]}-${[ids.comBuraco]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.road.hole")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.pista][ids.outros]}
                            id={`${[ids.pista]}-${[ids.outros]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.others")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Stack mt="10px">
                <Text fontWeight="bold">{t('boat.new.signaling.title')}</Text>

                <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.inexistente]}
                            id={`${[ids.sinalizacao]}-${[ids.inexistente]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.non-existent")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.agenteMobilidadeUrbana]}
                            id={`${[ids.sinalizacao]}-${[ids.agenteMobilidadeUrbana]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.agent")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.semaforo]}
                            id={`${[ids.sinalizacao]}-${[ids.semaforo]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.traffic-light")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.faixaDePedestre]}
                            id={`${[ids.sinalizacao]}-${[ids.faixaDePedestre]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.crossing")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.linha]}
                            id={`${[ids.sinalizacao]}-${[ids.linha]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.line")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.lombadaEletronica]}
                            id={`${[ids.sinalizacao]}-${[ids.lombadaEletronica]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.signaling.eletronic-bump")}
                        </Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox
                            isChecked={formData[ids.sinalizacao][ids.outros]}
                            id={`${[ids.sinalizacao]}-${[ids.outros]}`}
                            onChange={handleInputChange}
                            colorScheme="blue"
                        >
                            {t("boat.new.others")}
                        </Checkbox>
                    </FormControl>
                </SimpleGrid>
            </Stack>

            <Flex w="100%" justify="space-between" mt="20px">
                <Button
                    variant="light"
                    fontSize="sm"
                    w="125px"
                    onClick={onBack}
                >
                    {t("system.actions.back")}
                </Button>
                <Flex>
                    <Button
                        w="150px"
                        variant="solid"
                        fontSize="sm"
                        mr="10px"
                        onClick={saveDraft}
                    >
                        {t('boat.actions.draft')}
                    </Button>
                    <Button
                        w="125px"
                        variant="dark"
                        fontSize="sm"
                        onClick={handleOnSubmit}
                    >
                        {t('system.actions.next')}
                    </Button>
                </Flex>
            </Flex>
        </>
    );
}

export default BoatConditionsForm;